import _classCallCheck from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/inserttablecommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { findOptimalInsertionPosition } from '@ckeditor/ckeditor5-widget/src/utils';
/**
 * The insert table command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'insertTable'` editor command.
 *
 * To insert a table at the current selection, execute the command and specify the dimensions:
 *
 *		editor.execute( 'insertTable', { rows: 20, columns: 5 } );
 *
 * @extends module:core/command~Command
 */

var InsertTableCommand = /*#__PURE__*/function (_Command) {
  _inherits(InsertTableCommand, _Command);

  var _super = _createSuper(InsertTableCommand);

  function InsertTableCommand() {
    _classCallCheck(this, InsertTableCommand);

    return _super.apply(this, arguments);
  }

  _createClass(InsertTableCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var model = this.editor.model;
      var selection = model.document.selection;
      var schema = model.schema;
      var validParent = getInsertTableParent(selection.getFirstPosition());
      this.isEnabled = schema.checkChild(validParent, 'table');
    }
    /**
     * Executes the command.
     *
     * Inserts a table with the given number of rows and columns into the editor.
     *
     * @param {Object} options
     * @param {Number} [options.rows=2] The number of rows to create in the inserted table.
     * @param {Number} [options.columns=2] The number of columns to create in the inserted table.
     * @param {Number} [options.headingRows=0] The number of heading rows.
     * @param {Number} [options.headingColumns=0] The number of heading columns.
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var selection = model.document.selection;
      var tableUtils = this.editor.plugins.get('TableUtils');
      var insertPosition = findOptimalInsertionPosition(selection, model);
      model.change(function (writer) {
        var table = tableUtils.createTable(writer, options);
        model.insertContent(table, insertPosition);
        writer.setSelection(writer.createPositionAt(table.getNodeByPath([0, 0, 0]), 0));
      });
    }
  }]);

  return InsertTableCommand;
}(Command); // Returns valid parent to insert table
//
// @param {module:engine/model/position} position


export { InsertTableCommand as default };

function getInsertTableParent(position) {
  var parent = position.parent;
  return parent === parent.root ? parent : parent.parent;
}